// Vendors
import React from 'react';
import { Outlet } from 'react-router-dom';

// Components
import Header from '@molecules/Header';

const MainLayout: React.FC = () => {
  return (
    <div className="main-layout">
      <Header />
      <div>
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
